var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.modifiers},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-checkbox',{attrs:{"color":"success"},model:{value:(item.considered),callback:function ($$v) {_vm.$set(item, "considered", $$v)},expression:"item.considered"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }